import {
  Lock,
  Check,
  Visibility,
  VisibilityOff,
  Close,
} from "@mui/icons-material";
import { Box } from "@mui/material";

interface ValidationItemProps {
  isValid: boolean;
  text: string;
}

const ValidationItem = ({ isValid, text }: ValidationItemProps) => (
  <Box
    className={`flex items-center gap-2 `}
    fontWeight={500}
    color={`${isValid ? "primary.dark" : "gray.darkest"}`}
  >
    {isValid ? (
      <Check
        width={16}
        height={16}
        viewBox="0 0 24 24"
        style={{ width: "16px", height: "16px" }}
      />
    ) : (
      <Close
        width={16}
        height={16}
        viewBox="0 0 24 24"
        style={{ width: "16px", height: "16px" }}
      />
    )}
    <span>{text}</span>
  </Box>
);

export default ValidationItem;
